import { SET_COURSES_TO_ADD } from '../constants/general'

const initialState = {
  coursesToAdd: []
}

export default function generalReducer(state = initialState, action) {
  switch (action.type) {
    case SET_COURSES_TO_ADD:
      return {
        ...state,
        coursesToAdd: action.courseArray
      }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/general.js